/**
 * @file DeliveryQuoteResultPanel.tsx
 * @description Результат расчёта: ошибка, причина отказа или список тарифов
 * (phase19.12 шаг 5). Общая часть для Sheet заказа и калькулятора в настройках.
 */

import { DeliveryQuoteReasonAlert } from "./DeliveryQuoteReasonAlert";
import { DeliveryTariffList } from "./DeliveryTariffList";
import type { DeliveryQuoteController } from "./useDeliveryQuote";
import { Alert } from "../ui/alert";

interface Props {
  controller: DeliveryQuoteController;
  carrierSettingsHref?: string | null;
  integrationsHref?: string | null;
  clientTariffCode?: number | null;
  clientPrice?: number | null;
}

export function DeliveryQuoteResultPanel({
  controller,
  carrierSettingsHref,
  integrationsHref,
  clientTariffCode,
  clientPrice,
}: Props) {
  const { quote, error, issue, running } = controller;

  return (
    <div className="flex flex-col gap-3">
      {issue ? <Alert severity="warning">{issue.message}</Alert> : null}
      {error ? <Alert severity="error">{error}</Alert> : null}

      {quote && !quote.available ? (
        <DeliveryQuoteReasonAlert
          reason={quote.reason}
          carrierSettingsHref={carrierSettingsHref}
          integrationsHref={integrationsHref}
          onRetry={() => void controller.run()}
        />
      ) : null}

      {quote && quote.available ? (
        <DeliveryTariffList
          quote={quote}
          selected={controller.selected}
          onSelect={controller.select}
          clientTariffCode={clientTariffCode}
          clientPrice={clientPrice}
          disabled={running}
        />
      ) : null}
    </div>
  );
}
